import { memo } from 'react';

/**
 * Sidebar icon for the intro and onboarding videos: a play triangle inside a
 * phone-shaped frame, which is what the feature is — video that plays on a
 * handset.
 *
 * Written rather than reusing `Reminder` (which the App content item borrows)
 * so the two neighbouring settings pages are distinguishable at a glance.
 * Follows the same convention as the rest of the nav: the stroke tracks the
 * active state, so the selected item darkens with the list instead of being
 * hard-coded to one colour the way `Info` is for its dark button.
 */
const SvgComponent = (props: any) => {
  const stroke = props.active ? 'black' : '#808080';

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* The handset. */}
      <rect
        x="5"
        y="1.66667"
        width="10"
        height="16.6667"
        rx="2"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* The play triangle, centred in the screen area. */}
      <path
        d="M8.75 7.5L12.5 10L8.75 12.5V7.5Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Play = memo(SvgComponent);
export default Play;
